import { getConnectedIotaProvider } from './getConnectedIotaProvider';
import { IotaProvider } from './IotaProvider';

export async function withProvider<Args, Result>({
  call,
  args,
}: {
  call: (args: Args & { provider: IotaProvider }) => Promise<Result> | Result;
  args: Args;
}) {
  const provider = getConnectedIotaProvider();
  return call({
    ...args,
    provider,
  });
}
